import { realtimeSubscribeFieldsFrom, shouldRenderViewForState } from '../../../shared/view-visibility.js'
import { readLoggedInUser, readUserToken } from './live-user-storage'

export function shouldRenderView (component) {

  return shouldRenderViewForState(component, {
    previewMode: typeof window !== 'undefined' && !!window.__superturbo_preview_mode,
    loggedIn: readLoggedInUser()
  })
}

export function realtimeSubscribeFields (routeParams) {

  return realtimeSubscribeFieldsFrom(routeParams, readUserToken())
}
